import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\AdminPanel\ContactsController::index
* @see app/Http/Controllers/AdminPanel/ContactsController.php:22
* @route '/admin-panel/contacts'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin-panel/contacts',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AdminPanel\ContactsController::index
* @see app/Http/Controllers/AdminPanel/ContactsController.php:22
* @route '/admin-panel/contacts'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AdminPanel\ContactsController::index
* @see app/Http/Controllers/AdminPanel/ContactsController.php:22
* @route '/admin-panel/contacts'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\ContactsController::index
* @see app/Http/Controllers/AdminPanel/ContactsController.php:22
* @route '/admin-panel/contacts'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\AdminPanel\ContactsController::index
* @see app/Http/Controllers/AdminPanel/ContactsController.php:22
* @route '/admin-panel/contacts'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\ContactsController::index
* @see app/Http/Controllers/AdminPanel/ContactsController.php:22
* @route '/admin-panel/contacts'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\ContactsController::index
* @see app/Http/Controllers/AdminPanel/ContactsController.php:22
* @route '/admin-panel/contacts'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\AdminPanel\ContactsController::destroy
* @see app/Http/Controllers/AdminPanel/ContactsController.php:49
* @route '/admin-panel/contacts/{contact}'
*/
export const destroy = (args: { contact: string | { id: string } } | [contact: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/admin-panel/contacts/{contact}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\AdminPanel\ContactsController::destroy
* @see app/Http/Controllers/AdminPanel/ContactsController.php:49
* @route '/admin-panel/contacts/{contact}'
*/
destroy.url = (args: { contact: string | { id: string } } | [contact: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { contact: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { contact: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            contact: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        contact: typeof args.contact === 'object'
        ? args.contact.id
        : args.contact,
    }

    return destroy.definition.url
            .replace('{contact}', parsedArgs.contact.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AdminPanel\ContactsController::destroy
* @see app/Http/Controllers/AdminPanel/ContactsController.php:49
* @route '/admin-panel/contacts/{contact}'
*/
destroy.delete = (args: { contact: string | { id: string } } | [contact: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\AdminPanel\ContactsController::destroy
* @see app/Http/Controllers/AdminPanel/ContactsController.php:49
* @route '/admin-panel/contacts/{contact}'
*/
const destroyForm = (args: { contact: string | { id: string } } | [contact: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\AdminPanel\ContactsController::destroy
* @see app/Http/Controllers/AdminPanel/ContactsController.php:49
* @route '/admin-panel/contacts/{contact}'
*/
destroyForm.delete = (args: { contact: string | { id: string } } | [contact: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const contacts = {
    index: Object.assign(index, index),
    destroy: Object.assign(destroy, destroy),
}

export default contacts